import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/discourse': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M225.9 32C103.3 32 0 130.5 0 252.1 0 256 0.1 480 0.1 480L225.9 479.8C348.6 479.8 448 377.5 448 255.9 448 134.3 348.6 32 225.9 32zM224 384C204.6 384 186.1 379.7 169.6 371.9L88.5 392 111.4 317C101.6 298.9 96 278.1 96 256 96 185.3 153.3 128 224 128S352 185.3 352 256 294.7 384 224 384z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/discourse.js
// module id = Oll7
// module chunks = 144